"use client";

import { AnimatePresence, m } from "motion/react";
import { SPRING_FAST } from "@/lib/motion";

interface AnimatedIconProps {
  active: boolean;
  activeIcon: React.ReactNode;
  idleIcon: React.ReactNode;
}

export function AnimatedIcon({
  active,
  activeIcon,
  idleIcon,
}: AnimatedIconProps) {
  return (
    <AnimatePresence initial={false} mode="popLayout">
      <m.span
        animate={{ filter: "blur(0px)", opacity: 1, scale: 1 }}
        aria-hidden="true"
        className="flex will-change-transform"
        exit={{ filter: "blur(4px)", opacity: 0, scale: 0.25 }}
        initial={{ filter: "blur(4px)", opacity: 0, scale: 0.25 }}
        key={active ? "active" : "idle"}
        transition={SPRING_FAST}
      >
        {active ? activeIcon : idleIcon}
      </m.span>
    </AnimatePresence>
  );
}
